import { render, staticRenderFns } from "./BtnAtualizarPrestacaoContasMensal.vue?vue&type=template&id=5851368e"
import script from "./BtnAtualizarPrestacaoContasMensal.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarPrestacaoContasMensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports